import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { supabase } from '../lib/supabaseClient';
import { LogoMark, Wordmark } from '../components/Logo';
import ThemeToggle from '../components/ThemeToggle';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';

export default function ResetPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== password2) { toast.error('Kata laluan tidak sepadan.'); return; }
    if (password.length < 6) { toast.error('Kata laluan minimum 6 aksara.'); return; }
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (error) { toast.error('Sesi tamat atau tidak sah. Minta pautan baru.'); return; }
    toast.success('Kata laluan dikemas kini. Sila log masuk.');
    await supabase.auth.signOut();
    navigate('/masuk', { replace: true });
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="flex items-center px-6 h-16 bg-card border-b border-border">
        <div className="flex items-center gap-2"><LogoMark size={34} /><Wordmark size="text-lg" /></div>
        <div className="ml-auto"><ThemeToggle /></div>
      </header>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8">
          <h1 className="text-2xl font-bold text-foreground">Set Semula Kata Laluan</h1>
          <p className="mt-2 text-muted-foreground">Masukkan kata laluan baru anda.</p>
          <form onSubmit={submit} className="mt-6 space-y-5" data-testid="reset-form">
            <div className="space-y-2">
              <Label htmlFor="pw">{t('kataLaluan')}</Label>
              <Input id="pw" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12" data-testid="reset-password" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="pw2">{t('sahkanKataLaluan')}</Label>
              <Input id="pw2" type="password" required value={password2} onChange={(e) => setPassword2(e.target.value)} className="h-12" data-testid="reset-password2" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-12 bg-brand text-white hover:bg-brand-royal" data-testid="reset-submit">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : t('simpan')}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
